/**
 * External dependencies
 */
import inherits from 'inherits';

export default class CurrentRetailerRental {
    constructor(cscom) {
        if (!(this instanceof CurrentRetailerRental)) {
            return new CurrentRetailerRental(cscom);
        }
        this.cscom = cscom;
    }

    get(data) {
        return this.cscom.req.get('/customer-site-api/retailer-rental/view', null, data);
    }

    list(data) {
        return this.cscom.req.get('/customer-site-api/retailer-rental/list', null, data);
    }

}
